import {
  IUserDetailsMetadata,
  TBillingDetailsDto,
  TCompanyDetailsDto,
  TOptOutDto,
  TProductDetailsDto,
  TRelationsDto,
  TUserDetailsDto
} from "../types";
import { ECompanyType, ESignupStep } from "features/common";

export interface IMockStepDataMap {
  [ESignupStep.UserDetails]: TUserDetailsDto;
  [ESignupStep.CompanyDetails]: TCompanyDetailsDto;
  [ESignupStep.ProductsDetails]: TProductDetailsDto;
  [ESignupStep.Billing]: TBillingDetailsDto;
  [ESignupStep.Checkout]?: any; // Replace with appropriate type
  [ESignupStep.SignupReason]?: any; // Replace with appropriate type
  [ESignupStep.Relations]?: TRelationsDto;
  [ESignupStep.OptOut]?: TOptOutDto;
}

export interface IMockMetadataMap {
  [ESignupStep.UserDetails]: IUserDetailsMetadata;
  [ESignupStep.CompanyDetails]?: any;
  [ESignupStep.ProductsDetails]?: any;
  [ESignupStep.Billing]?: any;
  [ESignupStep.Checkout]?: any;
  [ESignupStep.SignupReason]?: any;
  [ESignupStep.Relations]?: any;
  [ESignupStep.OptOut]?: any;
}

export const mockUserDetailsStepData: TUserDetailsDto = {
  isGuest: false,
  communityAccountId: 122,
  entityId: null,
  brand: "cl",
  language: "en",
  user: {
    firstName: "John",
    lastName: "Doe",
    emailAddress: "fluffypufs@test.com"
  }
};

export const mockCompanyDetailsStepData: TCompanyDetailsDto = {
  organisation: {
    name: "Acme Corp",
    tradeName: "Acme",
    registrationNumber: "ABC123456",
    establishmentNumber: "ABC123456",
    companyStatus: "Active",
    registeredCompanyAddress: {
      line1: "123 Business St",
      line2: "Suite 100",
      city: "Dubai",
      postcode: "00000",
      county: "Dubai County",
      country: "AE"
    },
    organisationTypes: ["supplier"],
    organisationCompanyTypeId: ECompanyType.Other,
    feeBandId: 0,
    vatNumber: "AE123456789",
    isGuest: false,
    organisationAccountId: null,
    entityId: null,
    phoneNumber: null,
    businessLine: null
  }
};

export const mockProductDetailsStepData: TProductDetailsDto = {
  subscription: {
    productSalesTypeIds: [512]
  }
};

export const mockBillingDetailsStepData: TBillingDetailsDto = {
  billing: {
    title: "",
    telephone: "",
    address: {
      line1: "5TH FLOOR, MINORIES HOUSE, 2-5 MINORIES, LONDON, UNITED KINGDOM, EC3N 1BJ",
      line2: "",
      city: "LONDON",
      postcode: "EC3N 1BJ",
      county: "",
      country: "GB"
    },
    firstName: "A",
    lastName: "B",
    emailAddress: "test@test.com"
  }
};

export const mockOptOutStepData: TOptOutDto = {
  optOut: {
    optOutProductSalesTypeIds: [332, 232]
  }
};

export const MOCK_STEP_DATA: IMockStepDataMap = {
  [ESignupStep.UserDetails]: mockUserDetailsStepData,
  [ESignupStep.CompanyDetails]: mockCompanyDetailsStepData,
  [ESignupStep.ProductsDetails]: mockProductDetailsStepData,
  [ESignupStep.Billing]: mockBillingDetailsStepData,
  [ESignupStep.OptOut]: mockOptOutStepData
};

export const mockUserDetailsMetadata: IUserDetailsMetadata = {
  productSiloName: "Constructionline"
};

export const MOCK_METADATA: IMockMetadataMap = {
  [ESignupStep.UserDetails]: mockUserDetailsMetadata,
  [ESignupStep.CompanyDetails]: {}
};

export function getMockStepData<T>(step: ESignupStep): T {
  return MOCK_STEP_DATA[step];
}

export function getMockMetadata<P>(step: ESignupStep): P {
  return MOCK_METADATA[step];
}
